<template>
 <div class="collection-info-section" :class="{'--open': isOpen}">
   <div class="collection-info-section__head" @click="changeOpen">
     <span class="h5 semibold">Цвета</span>
     <img src="~/assets/img/svg/common/arrow-down.svg" alt=""/>
   </div>
   <div class="collection-info-section__body">
     <div class="collection-colors-list">
       <div
         v-for="(color, index) in colors"
         :key="`color-item-${index}`"
         class="color-item tooltip"

         @click="openPopup(color)"
       >
         <div class="--color tooltip__item">
           <nuxt-img
             :src="String(color.imageId)"
             width="84"
             height="84"
             :alt="`color-${index}-image-${color.imageId}`"
           />
         </div>
         <div class="tooltip__hover">
           {{ color.value }}
         </div>
       </div>
       <div v-if="colorsCount > 4 && !isFull" class="more-button" @click="changeFull">
         <img src="~/assets/img/svg/common/arrow-down.svg" alt=""/>
       </div>
       <div v-if="isFull" class="more-button --close" @click="changeFull">
         <img src="~/assets/img/svg/common/arrow-down.svg" alt=""/>
       </div>
     </div>
     <div
       v-if="colorsMessage"
       v-html="colorsMessage"
       class="collection-colors-message h5"
       :class="{'collection-colors-message_decoration': getCharFromRedactor(fullColorMessageCharacteristic)}"
     />
   </div>

   <div v-if="isOpenPopup">
     <color-popup
       :item="selectedColor"

       @close="closePopup"
     />
   </div>
 </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { getCharacteristicFromFull } from '~/utils/getCharacteristic';
import getCharFromRedactor from '~/utils/getCharFromRedactor'
import type {IColor} from "~/components/collection/ColorPopup.vue";
import colorPopup from '~/components/collection/ColorPopup.vue'
// const colorPopup = defineAsyncComponent(() => import('~/components/collection/ColorPopup.vue'));

const props = defineProps({
  product: {
    type: Object as any,
    default: () => {}
  }
});

// state
const isOpen: any = ref(true);
const isFull: any = ref(false);
const isOpenPopup: any = ref (false);
const selectedColor = ref<IColor | null>(null);
// computed
const colors = computed(() => {
  const brandInternal = getCharacteristicFromFull(props?.product?.characteristics, 'brand-internal')?.values?.[0]?.value || "";
  let values = getCharacteristicFromFull(props.product?.characteristics, 'collection_color')?.values || [];
  values = values.map((_value: any) => {
    let _strValue: string = String(_value?.value || '');
    if (!!brandInternal) {
      _strValue = _strValue.replace(`${brandInternal}: `, '');
    }
    return {
      ..._value,
      value: _strValue
    }
  });
  if (!isFull.value) {
    return [...values].splice(0, 4)
  }
  return values
});
const colorsCount = computed(() => {
  return (getCharacteristicFromFull(props.product?.characteristics, 'collection_color')?.values || [])?.length
});
const colorsMessage = computed(() => {
  const characteristic = getCharacteristicFromFull((props.product?.characteristics || []), 'description_color');
  if (!characteristic) {
    return ''
  }
  return characteristic?.values?.[0]?.value || '';
});

const fullColorMessageCharacteristic = computed(() => {
  return getCharacteristicFromFull((props.product?.characteristics || []), 'description_color');
})

// methods
const changeOpen = () => {
  isOpen.value = !isOpen.value;
};
const changeFull = () => {
  isFull.value = !isFull.value;
}
const openPopup = function(color: IColor | null) {
  selectedColor.value = color;
  isOpenPopup.value = true;
}
const closePopup = () => {
  isOpenPopup.value = false;
  selectedColor.value = null;
}
</script>

<style lang="scss" scoped>
.collection-colors-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: -17px;
  margin-left: -17px;

  & > * {
    width: 60px;
    height: 60px;
    margin-top: 17px;
    margin-left: 17px;
  }
}

.collection-colors-message {
  margin-top: 16px;
  color: #989898;
}

.color-item {
  position: relative;

  .--color {
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    border: 1px solid #989898;

    img {
      object-fit: cover;
      position: absolute;
      top: 50%; left: 50%;
      transform: translate(-50%, -50%);
      padding: 1px;
      width: 100%;
      height: 100%;
      border-radius: 15px;
    }
    &:after {
      content: "";
      float: left;
      padding-top: 100%;
    }
    &:hover {
      border-color: #404040;
    }
  }
}

.more-button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #F4F3F1;
  border-radius: 15px;
  &:hover {
    border-color: #404040;
  }

  img {
    width: 32px;
    filter: invert(82%) sepia(5%) saturate(18%) hue-rotate(76deg) brightness(91%) contrast(87%);
  }
  &.--close img {
    transform: rotate(180deg);
  }
}

@media (max-width: 1023px) and (min-width: 640px) {
  .collection-colors-list .tooltip {
    &:nth-child(1), &:nth-child(2),
    &:nth-child(10n + 1), &:nth-child(10n + 2) {
      .tooltip__hover {
        right: initial;
        left: 50%;
        border-radius: 15px;
        border-bottom-left-radius: 0;

        &:after {
          right: initial;
          left: 0;
          border-right: initial;
          border-left: 15px solid #F4F3F1;
        }
      }
    }
  }
}
@media (max-width: 859px) {
  .collection-colors-list {
    margin-top: -10px;
    margin-left: -10px;

    &> * {
      width: calc(100% / 10 - 10px);
      height: auto;
      margin-top: 10px;
      margin-left: 10px;
      border-radius: 8px;
    }
  }
  .color-item {
    .--color {
      border-radius: 8px;
      img {
        border-radius: 8px;
      }
    }
  }
}
@media (max-width: 639px) {
  .collection-colors-list .tooltip {
    &:nth-child(1), &:nth-child(2),
    &:nth-child(6n + 1), &:nth-child(6n + 2) {
      .tooltip__hover {
        right: initial;
        left: 50%;
        border-radius: 15px;
        border-bottom-left-radius: 0;

        &:after {
          right: initial;
          left: 0;
          border-right: initial;
          border-left: 15px solid #F4F3F1;
        }
      }
    }
  }
  .collection-colors-list {
    & > * {
      width: calc(100% / 6 - 10px);
    }
  }
}
</style>

<style>
.collection-colors-message {
  &.collection-colors-message_decoration {
    a {
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
